import { Injectable, Injector } from '@angular/core';

import { BitfApiService } from '@bitf/services/api/bitf-api.service';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionPlanService extends BitfApiService {
  constructor(public injector: Injector) {
    super('subscription-plan', injector);
  }
}
